export default __webpack_public_path__ + "content/86128b71644abd479cfb452e9ab97d55.svg";